import React, { useEffect, useState } from "react";
import { serviceicon2, serviceicon3, serviceicon4 } from "../../assets/img";
import { useSelector } from "react-redux";
// import { data } from "../edit/data";

function SectionFiveThemeTwo() {
  const jsonData: any = useSelector<any>((state) => state.homeJsonList);
  // const jsonData = data

  return (
    <>
      <section className="services-section" id="services-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-card">
                <div className="section-title2">
                  <h2>{jsonData?.theme_2?.home?.section_5?.title} </h2>
                </div>
                <div className="services-slider">
                  <div className="row">
                    {jsonData?.theme_2?.home?.section_5?.cards.map((cards: any,cardIndex:any) => {
                      return (
                        <>
                          <div className="col-md-3">
                            <div className={`services-slider-grid ${cardIndex == 0 ?"services-slider-grid-lbl":""}`}>
                              <img src={cards.icon} alt="" />
                              <h5>{cards.card_title}</h5>
                              <ul>
                                {cards?.card_options.map((items: any) => {
                                  return (
                                    <>
                                      <li>{items}</li>
                                    </>
                                  );
                                })}
                              </ul>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SectionFiveThemeTwo;
